import * as React from 'react';
import { StyledYellowHeader, useStyles } from './styles';
import Grid from '@mui/material/Grid';
import CardMedia from '../../shared/cardMedia';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { Spacer } from 'src/components/shared';

export default function HomeBannerSection({ title, sectionData = [], homePage = {}, loading }) {
  const classes = useStyles();
  const data = sectionData?.filter((k) => k.published);
  if (!sectionData.length) return null;
  return (
    <Card>
      <CardContent sx={{ backgroundColor: '#0C1721', padding: '24px' }}>
        <Typography color="secondary" variant="h2">
          {title}
        </Typography>
        <Spacer x={2} y={2} />
        <Grid container>
          {data[0] && data[0].id && (
            <Grid item xs={12} md={6}>
              <CardMedia
                src={data[0]?.largeTileImage}
                alt={data[0]?.title}
                id={data[0]?.id}
                contentType={data[0]?.contentType}
                data={data[0]}
                loading={loading}
                type="largeTileImage"
                isClickable={true}
              />
            </Grid>
          )}

          <Grid item xs={12} md={6}>
            <Stack direction="column" spacing={2} pl={2}>
              {data[1] && data[1].id && (
                <CardMedia
                  src={data[1]?.longTileImage}
                  alt={data[1]?.title}
                  id={data[1]?.id}
                  contentType={data[1]?.contentType}
                  data={data[1]}
                  loading={loading}
                  type={'longTileImage'}
                  isClickable={true}
                />
              )}

              <Stack direction="row" spacing={2}>
                {data[2] && data[2].id && (
                  <Box sx={{ flex: 1 }}>
                    <CardMedia
                      src={data[2]?.tallTileImage}
                      alt={data[2]?.title}
                      id={data[2]?.id}
                      contentType={data[2]?.contentType}
                      data={data[2]}
                      loading={loading}
                      type={'tallTileImage'}
                      isClickable={true}
                    />
                  </Box>
                )}

                {data[3] && data[3].id && (
                  <Box sx={{ flex: 1 }}>
                    <CardMedia
                      src={data[3]?.tallTileImage}
                      alt={data[3]?.title}
                      id={data[3]?.id}
                      contentType={data[3]?.contentType}
                      data={data[3]}
                      loading={loading}
                      type={'tallTileImage'}
                      isClickable={true}
                    />
                  </Box>
                )}
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
